/**
 * @namespace jwsdwUtil
 */
'use strict';

(function (angular) {

    config.$inject = ['$compileProvider'];
    angular.module('jwsdw.util', []).config(config);

    /**
     * @description config
     * @param {Object} $compileProvider angular compile provider
     * @returns {void}
     */
    function config($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
    }
}(angular));
